/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, object, func,
    shape, string, number,
} from 'prop-types';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import configENV from '../../../config';
import { deepObjectExtend, isEmpty } from '../../../utils/object';
import { combineStyle } from '../../../style/combineStyle';
import { main as MainStyle } from '../../../style/main';
import { DesktopSubscriptionListStyle } from '../../../style/DesktopSubscriptionListStyle';
import DesktopSubscriptionDetail from './DesktopSubscriptionDetail';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        DesktopSubscriptionListStyle,
    }),
);

function removeUSZipCodeSegment(zipcode) {
    if (/\d{5}-\d{4}/.test(zipcode)) {
        const zipSplit = zipcode.split('-');
        return zipSplit[0];
    }
    return zipcode;
}

function DesktopSubscriptionList({ subscriptions, classes, handleCancel }) {
    if (!subscriptions) {
        return null;
    }
    if (isEmpty(subscriptions)) {
        return <div>You have no product subscriptions</div>;
    }
    return (
        <div className={classes.list}>
            {subscriptions.map((subscription) => (
                <div key={subscription.ruleId} className={classes.DesktopSubscriptionListStyle}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid className={`${classes.orderProductMain} subscriptionListWrapper`}>
                                <Grid className="subscriptionHeader" container>
                                    <Grid className="subscriptionHeaderItem" item xs={12}>
                                        <span className="headerItemLabel">SHIP TO: </span>
                                        <span className="headerItemLabelInfo">
                                            {subscription.recipient[0].firstName}{' '}
                                            {subscription.recipient[0].lastName}{' '}-{' '}
                                            {subscription.recipient[0].street1}{' '}
                                            {subscription.recipient[0].street2 ? subscription.recipient[0].street2 : ''},{' '}
                                            {subscription.recipient[0].city},{' '}
                                            {subscription.recipient[0].state}{' '}
                                            {removeUSZipCodeSegment(subscription.recipient[0].zipcode)}
                                        </span>
                                    </Grid>
                                </Grid>
                                <Grid container className="subscriptionItemGrid">
                                    <DesktopSubscriptionDetail subscription={subscription} handleCancel={handleCancel} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            ))}
        </div>
    );
}

DesktopSubscriptionList.defaultProps = {
    subscriptions: [],
};

DesktopSubscriptionList.propTypes = {
    classes: object.isRequired,
    handleCancel: func.isRequired,
    subscriptions: arrayOf(
        shape({
            checkoutBrand: string,
            duration: number.isRequired,
            endDate: string.isRequired,
            interval: number.isRequired,
            nextOrderDate: string,
            orderDate: string.isRequired,
            orderHistoryResult: arrayOf(
                shape({
                    deliveryDate: string,
                    discountAmount: string,
                    orderDate: string.isRequired,
                    orderNumber: string.isRequired,
                    productCode: string.isRequired,
                    productName: string.isRequired,
                    productPrice: string.isRequired,
                    quantity: string.isRequired,
                }),
            ),
            orderNumber: string.isRequired,
            orderTime: string.isRequired,
            orderType: string.isRequired,
            price: string.isRequired,
            productId: string.isRequired,
            productImageCategory: string.isRequired,
            productImageThumbnail: string.isRequired,
            productName: string.isRequired,
            quantity: string,
            recipient: arrayOf(shape({
                city: string.isRequired,
                country: string.isRequired,
                firstName: string.isRequired,
                lastName: string.isRequired,
                state: string.isRequired,
                street1: string.isRequired,
                street2: string.isRequired,
                zipcode: string.isRequired,
            })),
            ruleId: string.isRequired,
            startDate: string.isRequired,
            subscriptionStatus: string.isRequired,
            totalAmount: string.isRequired,
        }),
    ),
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        subscriptions: newState.subscriptions,
        toggleState: newState.toggleState,    // hack to force a refresh
    };
};

export default connect(
    mapStateToProps,
    null,
)(withStyles(styles, { withTheme: true })(DesktopSubscriptionList));
